/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimelineBadge } from './timelineBadge';


/**
 * A single dated entry in an insight\'s history timeline, recording a past state change such as the insight triggering, being resolved, or expiring.
 */
export interface TimelineEvent { 
    /**
     * Date the event occurred, as an ISO 8601 date string (YYYY-MM-DD).
     */
    date: string;
    /**
     * Status colour for the timeline marker. \'error\' for an active/high-risk event, \'success\' for a resolved event, \'neutral\' for an expired or informational event, with \'warning\' and \'info\' for intermediate states.
     */
    indicator: TimelineEvent.IndicatorEnum;
    /**
     * Optional tags annotating the event, such as confidence or outcome labels.
     */
    badges?: Array<TimelineBadge>;
    /**
     * Short headline for the event.
     */
    title: string;
    /**
     * Fuller explanation of what happened at this point in the insight\'s history.
     */
    description: string;
}
export namespace TimelineEvent {
    export const IndicatorEnum = {
        Error: 'error',
        Success: 'success',
        Neutral: 'neutral',
        Warning: 'warning',
        Info: 'info'
    } as const;
    export type IndicatorEnum = typeof IndicatorEnum[keyof typeof IndicatorEnum];
}


